module.exports = __webpack_public_path__ + "img/hipercard-icon.dac55273.png";